import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE_URL, SITE_NAME, DEFAULT_IMAGE, pages, notFoundPage } from "./seo-config";

// Update the tag if index.html already has it, otherwise create it — avoids duplicate tags
function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([name, value]) => el.setAttribute(name, value));
}

function removeLinks(selector) {
  document.head.querySelectorAll(selector).forEach((el) => el.remove());
}

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const isGerman = /^\/de(\/|$)/.test(pathname);
    // Strip the /de prefix and any trailing slash to get the shared page path
    const stripped = pathname.replace(/^\/de(?=\/|$)/, "") || "/";
    const path = stripped.length > 1 ? stripped.replace(/\/+$/, "") : "/";

    const page = pages[path];
    const meta = page || notFoundPage;

    document.title = meta.title;
    setMeta("name", "description", meta.description);
    setMeta("name", "robots", page ? "index, follow" : "noindex, follow");

    if (page) {
      const enUrl = SITE_URL + path;
      const deUrl = SITE_URL + "/de" + (path === "/" ? "" : path);
      const url = isGerman ? deUrl : enUrl;

      setLink('link[rel="canonical"]', { rel: "canonical", href: url });
      setLink('link[rel="alternate"][hreflang="en"]', { rel: "alternate", hreflang: "en", href: enUrl });
      setLink('link[rel="alternate"][hreflang="de"]', { rel: "alternate", hreflang: "de", href: deUrl });
      setLink('link[rel="alternate"][hreflang="x-default"]', { rel: "alternate", hreflang: "x-default", href: enUrl });
      setMeta("property", "og:url", url);
    } else {
      // 404 pages should not point search engines at a canonical URL
      removeLinks('link[rel="canonical"], link[rel="alternate"][hreflang]');
    }

    setMeta("property", "og:title", meta.title);
    setMeta("property", "og:description", meta.description);
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:image", DEFAULT_IMAGE);
    setMeta("property", "og:locale", isGerman ? "de_DE" : "en_US");
    setMeta("name", "twitter:title", meta.title);
    setMeta("name", "twitter:description", meta.description);
    setMeta("name", "twitter:image", DEFAULT_IMAGE);
  }, [pathname]);

  return null;
}
